/*
 * Make the board stick on the cursor for 5 seconds so that it moves when user moves the mouse 
 * */
function boardOnCursor({ board, event }) {
  const maxAnimationLength = 3000;
  const radius = 60;
  const delay = 12;
  const padding = 32;
  const offsetMax = 2;
  let animationID = null;
  let center = { x: event.clientX, y: event.clientY };
  let lastTime = 0
  let degrees = 0;

  return new Promise((resolve) => {

    function setBoardPosition(currentTime) {
      if (lastTime + delay <= currentTime) {
        lastTime = currentTime;
        board.style.top = `${center.y - (board.getBoundingClientRect().height) +
          padding +
          (Math.sin((degrees % 360) * Math.PI / 180) * (radius + (Math.random() * offsetMax - (offsetMax * 2))))}px`;

        board.style.left = `${center.x - (board.getBoundingClientRect().width / 2) +
          padding +
          (Math.cos((degrees % 360) * Math.PI / 180) * (radius + (Math.random() * offsetMax - (offsetMax * 2))))}px`;
        degrees += 5;
      }
      animationID = window.requestAnimationFrame(setBoardPosition);
    }

    animationID = window.requestAnimationFrame(setBoardPosition);
    const sticky = (e) => {

      center.x = e.clientX;
      center.y = e.clientY;

      // board.style.top = `${e.clientY - (board.getBoundingClientRect().height) + padding}px `;
      // board.style.left = `${e.clientX - (board.getBoundingClientRect().width / 2)}px`;
    }

    document.addEventListener('mousemove', sticky);
    board.classList.add("party");
    setTimeout(() => {
      document.removeEventListener('mousemove', sticky);
      window.cancelAnimationFrame(animationID);
      board.classList.remove("party");
      resolve();
    }, maxAnimationLength);
  });
}

export default boardOnCursor;
